import React from 'react';

type SelectProps = {
  label?: string;
  error?: string;
  options: Array<{ key: string; value: string; label: string }>;
} & Omit<React.ComponentPropsWithRef<'select'>, 'className'>;

export const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
  ({ label, error, options, ...props }, ref) => {
    const id = React.useId();

    return (
      <div className="space-y-1">
        {label && (
          <label htmlFor={id} className="block text-sm font-medium text-gray-700">
            {label}
          </label>
        )}
        <select
          id={id}
          ref={ref}
          className={`
            block w-full rounded-md border-gray-300 shadow-sm py-2.5
            focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm
            ${error ? 'border-red-300' : ''}
          `}
          {...props}
        >
          {options.map((option) => (
            <option key={option.key} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        {error && <p className="text-sm text-red-600">{error}</p>}
      </div>
    );
  }
);

Select.displayName = 'Select';